/**
 * Owner: Masa Bayu
 * File: load-structured-page.ts
 * Date:Time: 2026-10-05 16:35
 * Description: Fasa 33-A GREEN · StructuredPage → LexicalEditor discrete load.
 */

import type { LexicalEditor } from 'lexical';
import type { StructuredPage } from '../types';
import { populateLexicalRootFromStructuredPage } from './lexical-adapter';

/**
 * Inject StructuredPage into editor state.
 * discrete:true flushes synchronously — required for headless reads and boot load.
 */
export function loadStructuredPageIntoEditor(
  editor: LexicalEditor,
  page: StructuredPage,
): void {
  editor.update(
    () => {
      populateLexicalRootFromStructuredPage(page);
    },
    { discrete: true },
  );
}
